"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imagesSchema = exports.imageSchema = exports.imageUrlsSchema = void 0;
const zod_1 = require("zod");
exports.imageUrlsSchema = zod_1.z
    .object({
    original: zod_1.z.string().describe("Relative path to original source image"),
    xs: zod_1.z
        .string()
        .regex(/\.webp$/)
        .describe("Relative path to optimized 100 × 100 px WebP image")
        .optional(),
    sm: zod_1.z
        .string()
        .regex(/\.webp$/)
        .describe("Relative path to optimized 200 × 200 px WebP image")
        .optional(),
    md: zod_1.z
        .string()
        .regex(/\.webp$/)
        .describe("Relative path to optimized 400 × 400 px WebP image")
        .optional(),
    lg: zod_1.z
        .string()
        .regex(/\.webp$/)
        .describe("Relative path to optimized 800 × 800 px WebP image")
        .optional(),
    xl: zod_1.z
        .string()
        .regex(/\.webp$/)
        .describe("Relative path to optimized 1200 × 1200 px WebP image")
        .optional(),
    "2xl": zod_1.z
        .string()
        .regex(/\.webp$/)
        .describe("Relative path to optimized 1600 × 1600 px WebP image")
        .optional(),
    "3xl": zod_1.z
        .string()
        .regex(/\.webp$/)
        .describe("Relative path to optimized 2400 × 2400 px WebP image")
        .optional(),
})
    .describe("Relative paths to image files for different sizes")
    .strict();
exports.imageSchema = zod_1.z
    .object({
    type: zod_1.z.enum(["avatar", "logo", "portrait", "opengraph", "twitter"]).describe("Type of the image"),
    urls: exports.imageUrlsSchema,
    width: zod_1.z.number().int().min(1).describe("Width of the original image in pixels").optional(),
    height: zod_1.z.number().int().min(1).describe("Height of the original image in pixels").optional(),
    alt: zod_1.z.string().describe("Alternative text for the image, used for accessibility").optional(),
})
    .describe("Specification of an image")
    .strict();
exports.imagesSchema = zod_1.z.array(exports.imageSchema).min(1).describe("List of images");
